import { Directive, computed, input } from '@angular/core';
import { cva, type VariantProps } from 'class-variance-authority';

import * as fromHelpers from '../helpers';

export enum NavSectionSizeVariant {
  collapsed = 'collapsed',
  expanded = 'expanded',
}

export enum NavSectionStatusVariant {
  default = 'default',
  selected = 'selected',
  disabled = 'disabled',
}

export const navSectionVariants = cva(
  fromHelpers.cn(
    'flex items-center justify-center relative overflow-hidden rounded',
    'transition-all duration-200 ease-in-out hover:cursor-pointer',
    '[&>svg]:size-24 [&>svg]:transition-colors [&>svg]:duration-200',
  ),
  {
    variants: {
      status: {
        [`${NavSectionStatusVariant.default}`]:
          'text-icon-neutral-enabled hover:bg-transparency-white-10',
        [`${NavSectionStatusVariant.selected}`]:
          'text-icon-primary-enabled hover:bg-transparency-white-10',
        [`${NavSectionStatusVariant.disabled}`]:
          'text-icon-neutral-disabled cursor-not-allowed hover:bg-transparent',
      },
      size: {
        [`${NavSectionSizeVariant.collapsed}`]: 'size-40 justify-center',
        [`${NavSectionSizeVariant.expanded}`]:
          'w-full h-56 justify-start pl-16 *:mr-16',
      },
    },
    defaultVariants: {
      status: NavSectionStatusVariant.default,
      size: NavSectionSizeVariant.collapsed,
    },
  },
);
export type NavSectionVariants = VariantProps<typeof navSectionVariants>;

@Directive({
  selector: '[dmcomNavSection]',
  standalone: true,
  host: {
    '[class]': 'className()',
  },
})
export class NavSectionDirective {
  readonly size = input<NavSectionVariants['size']>(
    NavSectionSizeVariant.collapsed,
  );
  readonly status = input<NavSectionVariants['status']>(
    NavSectionStatusVariant.default,
  );

  protected readonly className = computed(() =>
    fromHelpers.cn(
      navSectionVariants({
        size: this.size(),
        status: this.status(),
      }),
    ),
  );
}
